export enum ReviewPositiveReason {
    'EASY_TO_USE' = 'Easy to use',
    'CLEAR_INSTRUCTIONS_AND_SIGNS' = 'Clear instructions & signs',
    'FAIR_PRICE' = 'Fair price',
    'CLEAN_PARKING_LOT' = 'Clean parking lot',
    'OTHER' = 'Other',
}

export enum ReviewNegativeReason {
    'TOOK_TOO_LONG_TO_LOAD' = 'Took too long to load',
    'DIFFICULT_TO_USE' = 'Difficult to use',
    'PARKING_LOT_NOT_CLEAN' = 'Parking lot not clean',
    'SIGNAGE_NOT_CLEAR' = 'Signage not clear',
    'TOO_EXPENSIVE' = 'Too expensive',
    'OTHER' = 'Other',
}

export type ReviewReason = ReviewPositiveReason | ReviewNegativeReason;
export interface ReviewInterface {
    pk: number;
    created_at: string;
    comment: string | null;
    rating: number;
    slot: number;
    reason: ReviewReason | null;
}
